import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'
import { Store } from '@ngrx/store'
import { map, take } from 'rxjs'
import { selectToken } from '@/store/authentication/authentication.selector'
import { OpenAuthenticationService } from '@core/services/oauth.service'

/**
 * Blocks protected routes for unauthenticated callers. Reads the token snapshot (take(1) — no leaked
 * subscription) and, on a miss, kicks off the OIDC redirect to Identity. (Replaces the old inline guard,
 * which returned undefined and never actually gated.)
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const store = inject(Store)
  const authService = inject(OpenAuthenticationService)

  return store.select(selectToken).pipe(
    take(1),
    map((token) => {
      if (token && token.length > 0) {
        return true
      }
      // Remember where the user was headed so they return there after signing in.
      authService.redirectToLogin(state.url)
      return false
    })
  )
}
